module.exports = __webpack_public_path__ + "media/images/cropper_images/bg-1286921da9ca677bccc399b6b5a376b5.png";